import request from "../request";
import { REACT_BASE_URL_GAMA_SHAREPOINT } from "../url";

export const getDocumentsByRut = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_SHAREPOINT}/documents`,
    method: "POST",
    data,
  });
};

export const viewDocument = async (filename) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_SHAREPOINT}/documents/view?file=${filename.replaceAll(
      ";",
      "%3B",
    )}`,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadDocument = async (filename) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_SHAREPOINT}/documents/download?file=${filename.replaceAll(
      ";",
      "%3B",
    )}`,
    method: "GET",
    responseType: "blob",
  });
};
